import { render, staticRenderFns } from "./WidgetProductReviewsStatisticsPc.vue?vue&type=template&id=ee94387a&scoped=true"
import script from "./WidgetProductReviewsStatisticsPc.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsStatisticsPc.vue?vue&type=script&lang=js"
import style0 from "./WidgetProductReviewsStatisticsPc.vue?vue&type=style&index=0&id=ee94387a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee94387a",
  null
  
)

export default component.exports